module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("jJiHd"))).then(() => parcelRequire('lsDkS'));